import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { DialogMessage } from './Widgets/DialogMessage';
class TEST3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            input: '',
            scannedStuff: [],
            showDialog: false,
            isErrorMessage: false,
            actionDialog: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            summaryActive: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.addScannedTote = this.addScannedTote.bind(this);
    }

    componentDidMount() {
        this.focusOnInput();
    }

    handleInputChange(event) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;
        this.setState({
            input: value
        });
        this.focusOnInput();
    }

    focusOnInput() {
        document.getElementById('scanInput').focus();
    }

    addScannedTote(e) {
        e.preventDefault();
        const scannedStuff = this.state.scannedStuff;
        scannedStuff.push(this.state.input)
        this.setState({
            input: '',
            scannedStuff: scannedStuff
        });
    }

    render() {
        return (
            <div>
                <form action="#">
                    <input className="scanIdentifierInput" autoComplete="off" type="text" id="scanInput" name="scanInput" placeholder="Scan or Enter Tote #" value={this.state.input} onChange={this.handleInputChange}></input>
                    <button hidden type="submit" onClick={this.addScannedTote} />
                </form>
                <h1>Scanned Stuff</h1>
                {
                    this.state.scannedStuff.map(scannedThing => {
                        return (
                            <>
                                <div>*{scannedThing}*</div>
                                <br />
                            </>
                        );
                    })
                }
            </div>

        );
    }
}

export default withRouter(TEST3);
